import annotations from "./annotations";
import controlMenus from "./controlMenus";
import notation from "./notation";
import notes from "./notes";
import search from "./search";
import readerHeader from "./readerHeader";
import responsiveIframe from "./responsiveIframe";
import textMeta from "./textMeta";
import selectionList from "./selectionList";
import textSection from "./textSection";
import sectionCategoryLabel from "./sectionCategoryLabel";
import sectionPagination from "./sectionPagination";
import sectionNextSection from "./sectionNextSection";

export default `
${annotations}
${controlMenus}
${notation}
${notes}
${search}
${readerHeader}
${responsiveIframe}
${textMeta}
${selectionList}
${textSection}
${sectionCategoryLabel}
${sectionPagination}
${sectionNextSection}
`;
